import React, { FunctionComponent } from 'react';
import { Route, Switch } from 'react-router-dom';

import ProtectedRoute from 'components/ProtectedRoute';
import SignUp from 'components/UserMgmt/components/SignUp';
import Home from 'scenes/Home';
import MerchantStatusDetails from 'scenes/Home/scenes/MerchantStatusDetails';
import VenueStatusDetail from 'scenes/Home/scenes/VenueStatusDetail';
import VenueSearch from 'scenes/Home/scenes/VenueSearch';
import VenueDiscoverySearch from 'scenes/Home/scenes/VenueDiscoverySearch';
import NetworkHealth from 'scenes//NetworkHealth';
import Report from 'scenes/Report';
import BatchReport from 'scenes/Report/scenes/BatchReport';
import ReportDetail from 'scenes/Report/scenes/ReportDetail';
import NotFound from 'scenes/NotFound';
import CSVExport from 'scenes/CSVExport';
import UsersSummary from 'scenes/UsersSummary/UsersSummary';
import CardNetworkOnboarding from 'scenes/NetworkHealth/scenes/CardNetworkOnboarding';
import CreateMerchant from 'scenes/Home/scenes/MerchantManagement/CreateMerchant';

const InternalRoutes: FunctionComponent = () => (
  <Switch>
    <ProtectedRoute exact path="/" component={Home} />
    <ProtectedRoute exact path="/venues/search" component={VenueSearch} />
    <ProtectedRoute exact path="/network-health" component={NetworkHealth} />

    <ProtectedRoute
      path="/network-health/cn-onboarding"
      component={CardNetworkOnboarding}
    />

    <ProtectedRoute exact path="/sign-up" component={SignUp} />
    <Route path="/csv-export" component={CSVExport} />

    <ProtectedRoute
      exact
      path="/venue-discovery/search"
      component={VenueDiscoverySearch}
    />

    <ProtectedRoute
      exact
      path="/venues/search/venue/:venueId/:merchantId"
      component={VenueStatusDetail}
    />

    <ProtectedRoute
      path="/merchant/:merchantId"
      component={MerchantStatusDetails}
    />

    <ProtectedRoute exact path="/reports" component={Report} />
    <ProtectedRoute path="/reports/detail" component={ReportDetail} />
    <ProtectedRoute path="/reports/batch-report" component={BatchReport} />
    <ProtectedRoute path="/users-summary" component={UsersSummary} />
    <ProtectedRoute path="/create-merchant" component={CreateMerchant} />

    <Route component={NotFound} />
  </Switch>
);

export default InternalRoutes;
